
import { useEffect, useState } from 'react';

export default function ContactSection() {
  const [isContactVisible, setIsContactVisible] = useState(false);

  const openGoogleForm = () => {
    window.open('https://forms.gle/4W15Qq6ifk4bKthX6', '_blank');
  };

  const openWhatsApp = () => {
    window.open('https://wa.me/34698138711?text=Hola, me gustaría información sobre sus servicios de ilusionismo', '_blank');
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsContactVisible(entry.isIntersecting);
      },
      { threshold: 0.3 }
    );

    const contactSection = document.getElementById('contact');
    if (contactSection) {
      observer.observe(contactSection);
    }

    return () => {
      if (contactSection) {
        observer.unobserve(contactSection);
      }
    };
  }, []);

  return (
    <section id="contact" className="py-20 bg-black">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="font-elegant text-4xl md:text-5xl font-bold text-white mb-6">
            Reserva tu <span className="text-red-600">Espectáculo</span>
          </h2>
          <p className="text-gray-300 text-lg max-w-2xl mx-auto">
            ¿Listo para añadir magia a tu evento? Ponte en contacto para que podamos discutir cómo crear una experiencia mágica inolvidable con Stand-up Magic para tus invitados.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 max-w-6xl mx-auto">
          {/* Contact Information */}
          <div className="space-y-8">
            <div>
              <h3 className="text-2xl font-elegant font-semibold text-white mb-6">
                Vamos a Crear Magia Juntos
              </h3>
              <p className="text-gray-300 leading-relaxed mb-8">
                Ya sea para eventos corporativos, celebraciones familiares, festivales culturales o instituciones educativas, estoy aquí para hacer que tu ocasión sea verdaderamente mágica. Cada presentación se adapta a tus necesidades únicas y a tu público, incorporando valores positivos y mensajes educativos.
              </p>
            </div>

            <div className="space-y-4">
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center">
                  <i className="ri-phone-line text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="text-white font-semibold">Teléfono</h4>
                  <p className="text-gray-300">+34 698 13 87 11</p>
                </div>
              </div>

              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center">
                  <i className="ri-mail-line text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="text-white font-semibold">Email</h4>
                  <p className="text-gray-300">contacto@ilusionistamarcopombo.com</p>
                </div>
              </div>

              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center">
                  <i className="ri-map-pin-line text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="text-white font-semibold">Ubicación</h4>
                  <p className="text-gray-300">Galicia, Pontevedra</p>
                </div>
              </div>
            </div>

            {/* Social Media */}
            <div>
              <h4 className="text-white font-semibold mb-4">Sigue la Magia</h4>
              <div className="flex space-x-4">
                <a href="https://www.facebook.com/profile.php?id=61578282357138" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-800 hover:bg-red-600 text-white hover:text-white rounded-full flex items-center justify-center transition-all duration-300 cursor-pointer">
                  <i className="ri-facebook-fill"></i>
                </a>
                <a href="https://www.instagram.com/ilusionistamarcopombo" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-800 hover:bg-red-600 text-white hover:text-white rounded-full flex items-center justify-center transition-all duration-300 cursor-pointer">
                  <i className="ri-instagram-line"></i>
                </a>
                <a href="https://www.youtube.com/@magomarco" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-800 hover:bg-red-600 text-white hover:text-white rounded-full flex items-center justify-center transition-all duration-300 cursor-pointer">
                  <i className="ri-youtube-line"></i>
                </a>
                <a href="https://www.linkedin.com/in/marco-pombo-540278386/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-800 hover:bg-red-600 text-white hover:text-white rounded-full flex items-center justify-center transition-all duration-300 cursor-pointer">
                  <i className="ri-linkedin-fill"></i>
                </a>
              </div>
            </div>
          </div>

          {/* Contact Form Card */}
          <div className="bg-gray-900/50 backdrop-blur-sm border border-gray-800 rounded-lg p-8 text-center">
            <div className="mb-8">
              <div className="w-20 h-20 mx-auto mb-6 bg-red-600 rounded-full flex items-center justify-center">
                <i className="ri-mail-send-line text-white text-3xl"></i>
              </div>
              <h3 className="text-2xl font-elegant font-semibold text-white mb-4">
                Formulario de Contacto
              </h3>
              <p className="text-gray-300 leading-relaxed mb-6">
                Completa nuestro formulario detallado para contarnos sobre tu evento. 
                Responderemos rápidamente con una propuesta personalizada.
              </p>
              <div className="bg-black/30 rounded-lg p-4 mb-6">
                <ul className="text-left space-y-2 text-sm text-gray-300">
                  <li className="flex items-center">
                    <i className="ri-check-line text-red-600 mr-2"></i>
                    Información sobre el evento
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line text-red-600 mr-2"></i>
                    Número de invitados
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line text-red-600 mr-2"></i>
                    Ubicación y fecha
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line text-red-600 mr-2"></i>
                    Requisitos especiales
                  </li>
                </ul>
              </div>
            </div>

            <div className="space-y-3">
              <button 
                onClick={openGoogleForm}
                className="w-full bg-red-600 hover:bg-red-700 text-white px-8 py-3 rounded-lg font-semibold transition-all duration-300 hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
              >
                <i className="ri-external-link-line mr-2"></i>
                Abrir Formulario de Contacto
              </button>
              
              <p className="text-gray-300 text-sm py-2">O si prefieres...</p>
              
              <button 
                onClick={openWhatsApp}
                className="w-full bg-emerald-500 hover:bg-emerald-600 border border-emerald-500 hover:border-emerald-600 text-white px-8 py-3 rounded-lg font-semibold transition-all duration-300 hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line mr-2"></i>
                Contactar por WhatsApp
              </button>
            </div>
            
            <p className="text-xs text-gray-400 mt-4">
              Ambas opciones se abrirán en una nueva ventana
            </p>
          </div>

        </div>

        {/* WhatsApp Floating Button - Hidden when contact section is visible */}
        <div className={`fixed bottom-6 right-6 z-40 transition-all duration-300 ${
          isContactVisible ? 'opacity-0 pointer-events-none scale-90' : 'opacity-100 scale-100'
        }`}>
          <a 
            href="https://wa.me/34698138711" 
            target="_blank" 
            rel="noopener noreferrer"
            className="bg-green-500 hover:bg-green-600 text-white w-14 h-14 rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer"
          >
            <i className="ri-whatsapp-line text-2xl"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
